import React from "react";
import Overview from "./Overview";
import Add from "./Add";
import Edit from "./Edit";

import { ReligionProvider } from "../../context/ReligionContext";

export const Religion = () => {
  return (
    <ReligionProvider>
      <Overview />
    </ReligionProvider>
  );
};

export const AddReligion = () => {
  return (
    <ReligionProvider>
      <Add />
    </ReligionProvider>
  );
};

export const EditReligion = () => {
  return (
    <ReligionProvider>
      <Edit />
    </ReligionProvider>
  );
};
